function removeUnused(properties) {
  for (var i = properties.length - 1; i >= 0; i--) {
    var property = properties[i];

    if (property.unused) {
      property.all.splice(property.position, 1);
    }
  }
}

module.exports = removeUnused;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/optimizer/remove-unused.js
// module id = 593
// module chunks = 0